import { fetchDataAndProceed } from '../../config/utils'
import { METHOD_TYPES } from '../../config/constants'

export const getAllBrandFunctions = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/botBuilder/brandFunctionList', METHOD_TYPES.GET, data, callback)
}

export const createBrandFunction = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/botBuilder/brandFunction', METHOD_TYPES.POST, data, callback)
}

export const getBrandFunction = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/botBuilder/brandFunction', METHOD_TYPES.GET, data, callback)
}

export const updateBrandFunction = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/botBuilder/brandFunction', METHOD_TYPES.PUT, data, callback)
}

export const getImportedFilesForBrandFunction = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/botBuilder/brandFunctionFile', METHOD_TYPES.GET, data, callback)
}


// WEBPACK FOOTER //
// ./src/data/redux/brand_function_details/api.js